import React from 'react';
import { accountInfoPopoverContent } from '../../constants/staticContent';
import { useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from '../../hooks/useTranslation';

const AccountInfoContent = () => {
	const { t } = useTranslation();
	const theme = useTheme();
	const mobileScreen = useMediaQuery(theme.breakpoints.down('md'));
	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				gap: 4,
				padding: '1rem',
			}}
		>
			{accountInfoPopoverContent.map((text) => (
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						gap: 2,
						maxWidth: mobileScreen ? '15rem' : '20rem',
					}}
				>
					<div style={{ fontWeight: 700 }}>{t(text.title)}</div>
					<div>{t(text.content)}</div>
				</div>
			))}
		</div>
	);
};

export default AccountInfoContent;
